import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector } from "react-redux";
import { useEffect,useState } from 'react';
import dayjs from 'dayjs';
import { Card, Box, Typography } from "@mui/material";

export default function Valuecard(props){
    const theme = useSelector((state) => state.themedata.theme)
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    const [values, setValues] = useState([]);
    const [units, setUnits] = useState([]);
    const [optionname, setOptionname] = useState([]);

    useEffect(() => {
        var tagProperties = props.widgetprop.props.extended.tagprops;
        console.log("tagProperties in VALUECARD",tagProperties)
        var widgetname = props.widgetprop.widgetname;
        var valuearray = [];
        var unitsarray =[];
        var optionnamearray = [];

        tagProperties.forEach(chartType => {
            console.log("chartType in VALUECARD",chartType)

            if (tagcollectionvalue.hasOwnProperty(chartType.tagname)) {
                var nestedvalue = tagcollectionvalue[chartType.tagname];
                console.log("nestedvalue in Valuecard",nestedvalue)
                var curroptionname = chartType.optionname;
                var currunitname = chartType.optionunit;
                var sum = 0.0;
                console.log("VALUECARD sum before -sum",sum)
                for(let i=0;i<nestedvalue.length;i++){
                    sum = sum + Number(nestedvalue[i].y);
                    console.log("VALUECARD sum in loop",sum);    
                }
                console.log("VALUECARD sum in loop after for loop",sum);   
                valuearray.push(Number(sum).toFixed(2));
                optionnamearray.push(curroptionname);
                unitsarray.push(currunitname);
                
            }
        })
       
        setValues(valuearray);
        setUnits(unitsarray);
        setOptionname(optionnamearray);

        
      },[props.widgetprop, tagcollectionvalue])

    return(
        <>
            <table style={{width:"100%",paddingLeft:"20px"}}>
            {
  
                values.map((currentselectedoption,index)=>{
                    {console.log("in Valuecard-optionname[index]",optionname[index],"values[index]",values[index],"units[index]",units[index])}
                    return  <tr style={{textAlign: "left", height:"50px"}}>
                                <td style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"14px",fontWeight:400,alignItems:"left"}}>{optionname[index]}</td>
                                <td style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"24px",fontWeight:400,alignItems:"left"}}>{values[index]}</td>
                                <td style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"24px",fontWeight:400,alignItems:"left"}}>{units[index]}</td>
                            </tr>
                })
            }
            </table>
        </>
    )
}